<template>
    <div class="frequency">
        <div v-for="(item, index) in list" :key="index">
            <div :class="item.enable==true?'frequency-headers':'frequency-header'" @click="chang(item,index)">
                <div class="frequency-font">
                    {{ item.name }}
                </div>
                <div :class="cont==item.id?'frequency-int':'frequency-inp'">
                </div>
            </div>
        </div>
        <div class="course-button" @click="gotime">确认</div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            list: [
                {
                    id: 1,
                    name: "一周一次",
                    enable: false
                },
                {
                    id: 2,
                    name: "一周两次",
                    enable: false
                },
                {
                    id: 3,
                    name: "一周三次",
                    enable: false
                },
                {
                    id: 4,
                    name: "一周四次",
                    enable: false
                },
                {
                    id: 5,
                    name: "每天上课",
                    enable: false
                },
            ],
            cont:null
        }
    },
    methods: {
        chang(e,index){
            console.log(e,index);
            this.cont = e.id
        },
        gotime(){
            this.$router.push({
                name:"Membercoursetime",
                query:{
                    id:this.cont,
                    leavefrequency:this.cont
                }
            })
        }
    },
}
</script>
<style lang="scss">
.frequency{
    height: 600px;
    position: relative;
}
.frequency-headers{
    margin: 20px 30px;
    position: relative;
    width: 860px;
    height: 88px;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    border: 1px solid #FC5623 ;
}
.frequency-header {
    position: relative;
    margin: 20px 30px;
    width: 860px;
    height: 88px;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    border: 1px solid #E6E8EB;
}
.frequency-font {
        margin: 32px 30px;
        display: inline-block;
        width: 80px;
        height: 24px;
        font-size: 20px;
        font-family: Inter-Regular, Inter;
        font-weight: 400;
        color: #000000;
        line-height: 23px;
    }

    .frequency-inp {
        position: absolute;
        right: 30px;
        top: 30px;
        display: inline-block;
        width: 28px;
        height: 28px;
        opacity: 1;
        border-radius: 50%;
        border: 1px solid #B8B8B8;
    }

    .frequency-int {
        position: absolute;
        right: 30px;
        top: 30px;
        display: inline-block;
        background-image: url('../../images/goods/icon_commone_1@2x.png');
        background-size: 100%;
        width: 28px;
        height: 28px;
        opacity: 1;
        border-radius: 50%;
        border: 1px solid #B8B8B8;
    }
    .course-button{
    line-height: 30px;
    width: 100px;
    text-align: center;
    background: #fd5624;
    color: #fff;
    position: absolute;
    bottom:20px;
    left: 44%;
    cursor: pointer;
    right: 50px;
}
</style>
